import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const CUSTOMER_IMG = "https://images.pexels.com/photos/7859953/pexels-photo-7859953.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const PRO_IMG = "https://images.pexels.com/photos/3772616/pexels-photo-3772616.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const ease = [0.22, 1, 0.36, 1];

const PathCard = ({ img, kicker, title, desc, cta, onClick, dark, testId, delay }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease }}
    className={`group relative overflow-hidden border border-border ${dark ? "bg-navy text-white" : "bg-white text-navy"}`}
    data-testid={testId}
  >
    <div className="overflow-hidden h-64">
      <img src={img} alt={title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
    </div>
    <div className="p-10 lg:p-12">
      <p className="uppercase tracking-[0.25em] text-flame font-heading font-bold text-sm mb-4">{kicker}</p>
      <h3 className="font-heading font-black tracking-tighter text-3xl lg:text-4xl">{title}</h3>
      <p className={`mt-4 text-base leading-relaxed ${dark ? "text-white/60" : "text-slate-500"}`}>{desc}</p>
      <button
        onClick={onClick}
        data-testid={`${testId}-btn`}
        className="mt-8 inline-flex items-center gap-3 bg-flame hover:bg-flame-dark text-white font-heading font-bold uppercase tracking-wider text-sm px-8 py-4 transition-transform hover:scale-[1.03]"
      >
        {cta}
        <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
      </button>
    </div>
  </motion.div>
);

export const Paths = () => {
  const navigate = useNavigate();
  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <PathCard
          testId="path-customer-card"
          img={CUSTOMER_IMG}
          kicker="For Homeowners"
          title="I Need a Service"
          desc="Tell us what you need, where you are, and when. Matching local professionals review your request and respond with offers — including urgent and emergency work."
          cta="Post a Request"
          onClick={() => navigate("/request/new")}
          dark
          delay={0}
        />
        <PathCard
          testId="path-professional-card"
          img={PRO_IMG}
          kicker="For Service Providers"
          title="I'm a Professional"
          desc="Build your company profile, choose your services and coverage areas, and receive matched project leads across North Alabama and Tennessee."
          cta="Apply to Join"
          onClick={() => navigate("/join?type=professional")}
          delay={0.15}
        />
      </div>
    </section>
  );
};

export default Paths;
